angular.module('cian.filterTag')
	.directive('filterTags', [
		"$rootScope",
		"$log",
		"$timeout",
		"$animate",
		"$debounce",
		"FilterService",
		"SaveSearchService",
		"UserService",
		"AnalyticsService",
		"QuickFilters",
		"FilterTagsService",
		($rootScope, $log, $timeout, $animate, $debounce, FilterService, SaveSearchService, UserService, AnalyticsService, QuickFilters, FilterTagsService) => ({
			scope: {
				tags: '='
			},
			template: require('../../templates/filter-tags.html'),
			restrict: 'EA',
			replace: true,
			link: function(scope, element, attrs) {
				var $window = $(window),
					$container = element,
					unwatchTags = null,
					unwatchSpecialTags = null,
					fitInOneLineTimeout = null,
					resizeHandlerDebounce = null,
					// Кешируем всё что можем, чтобы сократить количество вызовов DOM
					elementsWidthCache = {
						tags: {},
						// различные кнопки "Ещё n" могут иметь разную ширину - "Ещё 1" короче чем "Ещё 15"
						expandButtons: {},
						clearAndSaveButtons: null,
						specialTags: 0
					};

				// Отображаемые теги, uniqueId => true
				const shownTags = new Set();
				scope.tagIsShown = tag => shownTags.has(tag.uniqueId);

				// Кнопки "Ещё n"
				scope.expandButtons = [];
				// Конкретная кнопка "Ещё n", которая показывается на интерфейсе
				scope.shownExpandButton = null;
				// Флаг, который проставляется в true, если все теги не помещаются в одну линию
				scope.tagsDoNotFitInOneLine = false;

				scope.isMetroTagShown = FilterTagsService.isMetroTag;

				// Следим сразу, так как при загрузке фильтры могут помещаться в 1 строку,
				// а при уменьшении окна должны схлопнуться
				subscribeToWindowResize();

				// Кнопка "Очистить"
				scope.clear = () => {
					// Не очищаем быстрые фильтры
					FilterService.reset({
						ignore: FilterService.getCurrentQuickFilters()
					});

					AnalyticsService.trackCA('Listing', 'Clean_filter');
				};

				scope.isSaveAvailable = UserService.isAuthenticated;

				scope.saveBookmark = function() {
					$log.info('Save bookmark');
					SaveSearchService.saveSearch();

					window.ca && ca('event', {
						name: 'oldevent',
						category: 'subscription',
						action: 'Open',
						label: 'From_cat_save',
					});
				};

				scope.collapse = function () {
					scope.collapsed = true;
					watchTags(); // watch tags will call fitInOneLine on first digest cycle
				};

				$timeout(scope.collapse, 300); // timeout for Safari 8 to render tags

				scope.expand = function() {
					scope.collapsed = false;
					unwatchTags();
				};

				scope.$on('$destroy', function() {
					unsubscribeFromWindowResize();
				});

				// Код закомментирован, потому что убрали анимацию для тегов
				// в файле cian/static/newbuild/src/components/filter-tag/src/styles/cian.filter-tag.less
				//
				// called twice during leave animation with different phases: "start" and "close"
				// $animate.on('leave', $container, function(element, phase) {
				// 	// wait for animation to end and then fit all tags in one line
				// 	// to avoid possible moving of some of the tags to second line
				// 	debugger
				// 	if (phase === 'start') {
				// 		fitInOneLineTimeout && $timeout.cancel(fitInOneLineTimeout);
				// 	} else if (phase === 'close') {
				// 		fitInOneLine();
				// 	}
				// });

				function addNewExpandButtonsIfNeeded() {
					var expandButtonsCount = scope.expandButtons.length;
					var requiredExpandButtonsCount = scope.tags.length - 1;
					if (requiredExpandButtonsCount > expandButtonsCount) {
						for (var i = expandButtonsCount; i < requiredExpandButtonsCount; i++) {
							scope.expandButtons.push({count: i +  1});
						}
					}
				}

				function fitInOneLine() {
					// if code is queued using $timeout,
					// it should run after the DOM has been manipulated by Angular,
					// and after the browser renders
					fitInOneLineTimeout = $timeout(function() {
						var tagsLength = scope.tags.length;
						if (tagsLength === 0) {
							return;
						}
						// cache other elements of container once
						if (!elementsWidthCache.clearAndSaveButtons) {
							var $filterClearButton = $container.find('.js-button-clear'),
									$filterSaveButton = $container.find('.js-button-save');
							elementsWidthCache.clearAndSaveButtons = getActualWidth($filterClearButton) + getActualWidth($filterSaveButton);
						}
						if (!elementsWidthCache.specialTags && scope.isMetroTagShown) {
              var $metroDistanceTag = $container.find('.metro-distance');
              elementsWidthCache.specialTags = $metroDistanceTag.length > 0 ? getActualWidth($metroDistanceTag) : 0;
						}

						// lazy initialize jquery selectors
						var $filterTags,
								$expandButtons;

						shownTags.clear();
						scope.shownExpandButton = null;
						var remainingContainerWidth = $container.width() - elementsWidthCache.clearAndSaveButtons - elementsWidthCache.specialTags;
						// use traditional loop instead of angular.forEach cause latter doesn't have `break` functionality
						for (var i = 0; i < tagsLength; i++) {
							var tag = scope.tags[i],
									tagUniqueId = tag.uniqueId,
									filterTagWidth = elementsWidthCache.tags[tagUniqueId],
									expandButtonIndex = tagsLength - i - 2,
									// expandButtonIndex === -1 only if we are on last iteration cycle,
									// meaning that either all tags will fit or all except one
									expandButtonWidth = expandButtonIndex === -1 ? 0 : elementsWidthCache.expandButtons[expandButtonIndex];

							// Кешируем всё что можем
							if (!filterTagWidth) {
								if (!$filterTags) {
									$filterTags = $container.find('.js-button-tag');
								}
								filterTagWidth = getActualWidth($filterTags.get(i));
								elementsWidthCache.tags[tagUniqueId] = filterTagWidth;
							}
							if (angular.isUndefined(expandButtonWidth)) {
								if (!$expandButtons) {
									$expandButtons = $container.find('.js-button-expand');
								}
								expandButtonWidth = getActualWidth($expandButtons.get(expandButtonIndex));
								elementsWidthCache.expandButtons[expandButtonIndex] = expandButtonWidth;
							}

							remainingContainerWidth -= filterTagWidth;
							if (remainingContainerWidth - expandButtonWidth > 0) {
								shownTags.add(tag.uniqueId);
								scope.shownExpandButton = scope.expandButtons[expandButtonIndex];
							} else {
								break;
							}
						}
					});
				}

				function watchTags() {
					unwatchTags = scope.$watchCollection(function() {
						return scope.tags.map(tag => tag.uniqueId);
					}, function() {
						addNewExpandButtonsIfNeeded();
						fitInOneLine();
					});
					unwatchSpecialTags = $rootScope.$watch(function() {
						return FilterTagsService.isMetroTag;
					}, function(value) {
            scope.isMetroTagShown = value;
					})
				}

				function resizeHandler() {
					resizeHandlerDebounce = $debounce(fitInOneLine, 1000);
				}

				function subscribeToWindowResize() {
					$window.on('resize.filterTags', resizeHandler);
				}

				function unsubscribeFromWindowResize() {
					$debounce.cancel(resizeHandlerDebounce);
					$window.off('resize.filterTags');
				}

				// Используется jquery плагин jquery.actual, который временно меняет display на указанный
				// и считает ширину элемента, затем возвращает предыдущий display
				function getActualWidth(el) {
					return $(el).actual('outerWidth', {includeMargin: true, display: 'block'});
				}
			}
		})
	]);



// WEBPACK FOOTER //
// ./src/components/filter-tag/src/scripts/cian.filter-tags.dir.js